import React, { useContext } from 'react'
import { isIOS, isAndroid } from 'react-device-detect'
import { Box } from '@mui/system'
import { Button, Typography } from '@mui/material'
import { DEEP_LINK } from '~/constants'
import { AppStoreIcon, CapichiIcon, GooglePlayIcon, PolygonIcon } from '~/assets/icons'
import { useTranslation } from 'react-i18next'
import { ThemeContext } from '~/theme/ThemeProvider'
import { THEMES_NAME, variantStyles } from '~/theme/constants'
import ReactHtmlParser from 'react-html-parser'
import { getInfoRestaurant } from '~/utils'

const BottomAppInfo = () => {
  const { t } = useTranslation()
  const { currentThemeObject } = useContext(ThemeContext)
  const { deeplink_store_on_delivery } = getInfoRestaurant()

  const discoverAppHandler = () => {
    if (deeplink_store_on_delivery) {
      window.location.replace(deeplink_store_on_delivery)
      return
    }
    if (isIOS) {
      window.location.replace(DEEP_LINK.APP)
      setTimeout(() => {
        window.location.replace(DEEP_LINK.APP_STORE)
      }, 10000)
    }
    if (isAndroid) {
      window.location.assign(DEEP_LINK.GOOGLE_PLAY)
    }
  }

  return (
    <Box marginTop="22px" paddingBottom="32px" sx={styles.bottomBar}>
      <Box display="flex" justifyContent="flex-end">
        <Button
          onClick={discoverAppHandler}
          variant={
            currentThemeObject.value === THEMES_NAME.mango
              ? variantStyles.btnDiscoverForMango
              : variantStyles.btnOrder
          }
          sx={styles.btnDiscover}>
          <Typography fontWeight="600" color="baseColor.colorText3">
            {t('actions.discover')}
          </Typography>
          <Typography marginLeft="4px" sx={{ transform: 'rotate(180deg)', lineHeight: '0' }}>
            <PolygonIcon color={currentThemeObject.colorText3} />
          </Typography>
        </Button>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="flex-end" marginTop="4px">
        {/* view left */}
        <Box maxWidth="40%" display="flex" flexDirection="column">
          <Typography
            textAlign="center"
            component="div"
            fontSize="1rem"
            marginBottom="4px"
            fontWeight="300"
            color={'baseColor.colorText1'}>
            {t('label.powered_by')}
          </Typography>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <CapichiIcon width="30" height="32" />
            <Typography marginLeft="10px" fontWeight="500" color={'baseColor.colorText1'}>
              Capichi
            </Typography>
          </Box>
        </Box>
        {/* /view right */}
        <Box
          maxWidth="50%"
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          justifyContent="flex-end">
          <Typography fontSize="1.2rem" color={'baseColor.colorText1'} textAlign="end">
            {ReactHtmlParser(
              t('descriptions.restaurant_on_capichi', {
                colorText: currentThemeObject.color5 || 'black',
              }),
            )}
          </Typography>

          <Box display="flex" flexDirection="row" marginTop="4px">
            <Box marginRight="8px" display="flex">
              <AppStoreIcon />
            </Box>
            <Box display="flex">
              <GooglePlayIcon />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  btnDiscover: {
    fontSize: '1.6rem',
    lineHeight: '2rem',
    padding: '10px 16px',
    alignItems: 'center',
    display: 'flex',
  },
}

export default BottomAppInfo
